export const validationErrorHandler = (error, setFormErrors) => {
  if (["UNIQUE_VALIDATION", "REQUIRED_VALIDATION"].indexOf(error.type) === -1) return;
  Object.keys(error.data.keyValue).forEach((key) => {
    setFormErrors((state) => ({ ...state, [key]: error.message }));
  });
};
